export const MyPokemonStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    margin: 'auto',
    padding: '10px',
    justifyContent: 'center',
}